import React, { useContext, useReducer } from "react";
import distribucionesReducer from "./distribucionesReducer.js";
import distribucionesContext from "./distribucionesContext.js";

//Socket
import { SocketContext } from "../socket/socket";

import { getAbmDistribucion, uploadAbmDistribucion, getAbmSubcuentaDistribucion } from "../../api/abmDistribution.js";

import {
    ACTUALIZAR_DISTRIBUCIONES,
    ACTUALIZAR_SUBCUENTAS_DISTRIBUCION,
    ACTUALIZAR_DISTRIBUCIONES_DB,
    CARGANDO_DISTRIBUCIONES,
    ERROR_DISTRIBUCIONES,
    LIMPIAR_ERROR_DISTRIBUCIONES
} from "./distribucionesActions.js";

const DistribucionesState = props => {

    const server = useContext(SocketContext);

    const initialState = {
        distribuciones: [],
        subcuentasDistribucion: [],
        cargando: false,
        error: ""
    };

    const [state, dispatch] = useReducer(distribucionesReducer, initialState);

    const actualizarDistribuciones = async () => {
        try {
            const resp = await getAbmDistribucion();
            dispatch({
                type: ACTUALIZAR_DISTRIBUCIONES,
                payload: resp.data.data
            });
            return resp.data.data;
        } catch (error) {
            console.log(error);
        }
    };

    const actualizarSubcuentasDistribucion = async () => {
        try {
            const resp = await getAbmSubcuentaDistribucion();
            dispatch({
                type: ACTUALIZAR_SUBCUENTAS_DISTRIBUCION,
                payload: resp.data.data
            });
            return resp.data.data;
        } catch (error) {
            console.log(error);
        }
    };

    const actualizarDistribucionesDB = async () => {
        try {
            // El endpoint solo confirma que el proceso arrancó en segundo plano;
            // hay que esperar el aviso por socket para saber el resultado real.
            await uploadAbmDistribucion();

            if (!server) {
                throw new Error("No hay conexión en tiempo real disponible. Recargue la página e intente nuevamente.");
            }

            const resultado = await new Promise((resolve) => {
                server.once("actualizarAbmDistribucionFinalizado", resolve);
            });

            if (resultado.status !== 200) {
                dispatch({
                    type: ERROR_DISTRIBUCIONES,
                    payload: resultado.message
                });
                return { status: false, msg: resultado.message };
            }

            const resp = await getAbmDistribucion();
            dispatch({
                type: ACTUALIZAR_DISTRIBUCIONES_DB,
                payload: resp.data.data
            });
            return { status: true, msg: "Se actualizó con éxito la base de datos." };
        } catch (error) {
            console.log(error);
            const errMsg = error.response?.data?.errMsg || error.response?.data?.message || error.message;
            dispatch({
                type: ERROR_DISTRIBUCIONES,
                payload: errMsg
            });
            return { status: false, msg: errMsg };
        }
    };

    const cargando = () => {
        dispatch({ type: CARGANDO_DISTRIBUCIONES });
    };

    const limpiarError = () => {
        dispatch({ type: LIMPIAR_ERROR_DISTRIBUCIONES });
    };

    return (
        <distribucionesContext.Provider
            value={{
                distribuciones: state.distribuciones,
                subcuentasDistribucion: state.subcuentasDistribucion,
                isCargando: state.cargando,
                error: state.error,
                actualizarDistribuciones,
                actualizarSubcuentasDistribucion,
                actualizarDistribucionesDB,
                cargando,
                limpiarError
            }}
        >
            {props.children}
        </distribucionesContext.Provider>
    );
};

export default DistribucionesState;
